import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Replaces next/link
import { Images } from "../../../assets/assets";
import FooterAbout from './footerAbout';
import SubscribeCol from './subscribecol';
import ContactCol from './contactcol';
import FollowUs from './followus';
import FooterNav from './footernav';
// import { HashLink } from "react-router-hash-link";


export default function MainFooter() {
	return (
		<div className="uper-footer">
			<div className="upper-block">
				<Container className='theme-container'>
					<Row>
						<Col className="position-relative" xxl={3} xl={4} md={6} lg={4}>
							<div className="uper-footer-col no-border ps-0">

								<FooterAbout />
								<FollowUs />
							</div>
						</Col>
						<Col className="position-relative" xxl={3} xl={4} md={6} lg={8}>
							<div className="uper-footer-col">
								<SubscribeCol />
							</div>
						</Col>
						<Col className="position-relative" xxl={3} xl={4} lg={4} md={6}>
							<div className="uper-footer-col">
								<FooterNav />
							</div>
						</Col>
						<Col className="position-relative" xxl={3} md={6}>
							<div className="uper-footer-col">
								<ContactCol />
							</div>
						</Col>
					</Row>
				</Container>
			</div>
			<div className="lower-block">
				<Container className='theme-container'>
					<div className='lower-block-content justify-content-center align-items-center'>
						<div className="copyright-text">
							<p>
								Copyright &copy; 2025
								<Link to="/" className='text-orange'> 5StarGrading</Link> . All Rights Reserved
							</p>
						</div>
						{/* <div className="footer-logo-wraper">
							<Link to="/" >
								<img className="img-fluid" src={Images.siteFooterLogo} alt="Site Logo" />
							</Link>
						</div> */}
						{/* <div className="bottom-footer-cms-list text-white">
							<ul>
								<li className="position-relative">
									<Link to="/privicy-policy">Privacy Policy</Link>
								</li>
								<li>
									|
								</li>
								<li>
									<HashLink smooth to="/#service-area">
										Sitemap
									</HashLink>
								</li>
							</ul>
						</div> */}
					</div>
				</Container>
			</div>
		</div>
	);
}
